/**
 * Modèle UI des documents officiels d'achat d'un bien.
 * Aligné sur le back ({@code DocumentAchatType}, {@code BienDocumentAchatDto}).
 */

export const DOCUMENT_ACHAT_TYPES = [
  'COMPROMIS_VENTE',
  'ATTESTATION_VENTE',
] as const;

export type DocumentAchatType = (typeof DOCUMENT_ACHAT_TYPES)[number];

/** Document d'achat actif (réponse API). */
export class BienDocumentAchat {
  idDocumentDto?: string;
  idBienDto?: string;
  typeDto!: DocumentAchatType;
  objectKeyDto?: string;
  fileNameDto?: string;
  contentTypeDto?: string;
  sizeBytesDto?: number;
  uploadedAtDto?: Date | string;
  dateDocumentDto?: Date | string | null;
  actifDto?: boolean;
}

/** Paramètres d'upload multipart. */
export interface DocumentAchatUploadParams {
  type: DocumentAchatType;
  dateDocument?: string | null;
  file: File;
}

/** Ligne UI : un type attendu + document courant éventuel. */
export interface DocumentAchatLigne {
  type: DocumentAchatType;
  document?: BienDocumentAchat;
}

/**
 * Construit les deux lignes (compromis / attestation) à partir de la liste API
 * (historique append-only : on garde le plus récent actif par type).
 */
export function lignesDocumentsAchat(
  documents: BienDocumentAchat[] | null | undefined
): DocumentAchatLigne[] {
  const byType = new Map<DocumentAchatType, BienDocumentAchat>();
  for (const document of documents ?? []) {
    if (!document?.typeDto || document.actifDto === false) {
      continue;
    }
    if (!byType.has(document.typeDto)) {
      byType.set(document.typeDto, document);
    }
  }
  return DOCUMENT_ACHAT_TYPES.map((type) => ({
    type,
    document: byType.get(type),
  }));
}
